// extracted by mini-css-extract-plugin
export default {"titleContainer":"FoldListItem-module--titleContainer--26Zw_","foldIcon":"FoldListItem-module--foldIcon--3Pr6y"};